import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ToastData {
  id: string;
  message: string;
  type: "success" | "error" | "warning" | "info" | "deleted";
  linkId?: string;
  linkName?: string;
  secondMessage?: string;
  timestamp: number;
}

interface ToastState {
  toasts: ToastData[];
}

const initialState: ToastState = {
  toasts: [],
};

const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    addToast: (
      state,
      action: PayloadAction<Omit<ToastData, "id" | "timestamp">>
    ) => {
      const newToast: ToastData = {
        ...action.payload,
        id: Date.now().toString(),
        timestamp: Date.now(),
      };
      state.toasts.push(newToast);
    },
    removeToast: (state, action: PayloadAction<string>) => {
      state.toasts = state.toasts.filter(
        (toast) => toast.id !== action.payload
      );
    },
    clearToasts: (state) => {
      state.toasts = [];
    },
  },
});

export const { addToast, removeToast, clearToasts } = toastSlice.actions;
export default toastSlice.reducer;
